import type { HazardousFilter } from './types';

export function isHazardousFilter(value: unknown): value is HazardousFilter {
  return value === '0' || value === '1';
}
